import React from "react";
import styles from "./notificationTemplates.module.css";
import failureIcon from "../../icons/error.svg";

const Failure = ({
  children,
  failureIconProps = {
    size: 16,
  },
}) => {
  return (
    <div className={[styles.template, styles.Failure].join(" ")}>
      <img
        src={failureIcon}
        alt="success"
        {...failureIconProps}
        width={failureIconProps.size}
        height={failureIconProps.size}
      />
      {children}
    </div>
  );
};

export default Failure;
